import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { TranslatePlain } from '../../../shared/LanguageService';
import { useTranslationForm } from '../state/useTranslationForm';
import { TranslationDto, translationLanguages } from '../types';

type TranslationFormProps = {
    translation: TranslationDto;
    onSaved: (saved: TranslationDto) => void;
    onCancel: () => void;
    onFailed: (message: string) => void;
};

function TranslationForm({ translation, onSaved, onCancel, onFailed }: TranslationFormProps) {
    const { values, canSave, errorFor, changeValue, save } = useTranslationForm(
        translation,
        onSaved,
        onFailed
    );

    return (
        <Box component="form" onSubmit={save} sx={{ marginTop: 2 }}>
            <Typography variant="caption" color="text.secondary">
                {TranslatePlain('translation-editor/label/key')}
            </Typography>
            <Typography sx={{ fontFamily: 'monospace', wordBreak: 'break-all', marginBottom: 1 }}>
                {translation.key}
            </Typography>
            {translationLanguages.map((language) => (
                <TextField
                    key={language}
                    label={TranslatePlain(`system/language/${language}`)}
                    value={values[language]}
                    onChange={(event) => changeValue(language, event.target.value)}
                    multiline
                    rows={3}
                    fullWidth
                    margin="normal"
                    error={errorFor(language) !== null}
                    helperText={errorFor(language) ? TranslatePlain(errorFor(language)) : ' '}
                    inputProps={{ 'aria-label': TranslatePlain(`system/language/${language}`) }}
                />
            ))}
            <Typography variant="caption" color="text.secondary" component="p">
                {TranslatePlain('translation-editor/helper/placeholders')}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ marginTop: 2 }}>
                <Button type="submit" variant="contained" disabled={!canSave}>
                    {TranslatePlain('translation-editor/button/save')}
                </Button>
                <Button type="button" variant="outlined" onClick={onCancel}>
                    {TranslatePlain('cancel')}
                </Button>
            </Stack>
        </Box>
    );
}

export default TranslationForm;
